module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cip-break"
  }, [_c('a', {
    attrs: {
      "id": "pIV"
    }
  }), _vm._v("Copyright © 2016 Neil Faulkner")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("All rights reserved. This book may not be reproduced in whole or in part, in any form (beyond that copying permitted by Sections 107 and 108 of the U.S. Copyright Law and except by reviewers for the public press) without written permission from the publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("For information about this and other Yale University Press publications, please contact:")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("U.S. Office:    "), _c('a', {
    attrs: {
      "href": "mailto:sales.press@yale.edu"
    }
  }, [_vm._v("sales.press@yale.edu")]), _vm._v(" "), _c('a', {
    staticClass: "www",
    attrs: {
      "href": "http://yalebooks.com",
      "target": "_blank"
    }
  }, [_vm._v("yalebooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Europe Office:    "), _c('a', {
    attrs: {
      "href": "mailto:sales@yaleup.co.uk"
    }
  }, [_vm._v("sales@yaleup.co.uk")]), _vm._v(" "), _c('a', {
    staticClass: "www",
    attrs: {
      "href": "http://yalebooks.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("yalebooks.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("Typeset in Minion Pro by IDSUK (DataConnection) Ltd")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Printed in Great Britain by Gomer Press, Llandysul, Ceredigion, Wales")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("Names: Faulkner, Neil, author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip1"
  }, [_vm._v("Title: Lawrence of Arabia’s war : the Arabs, the British, and the remaking of the Middle East in WWI / Neil Faulkner.")]), _vm._v(" "), _c('p', {
    staticClass: "cip1"
  }, [_vm._v("Description: New Haven : Yale University Press, 2016. | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip1"
  }, [_vm._v("Identifiers: LCCN 2015048301 | ISBN 9780300196832 (cloth : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "cip1"
  }, [_vm._v("Subjects: LCSH: World War, 1914–1918—Campaigns—Middle East. | Lawrence, T. E. (Thomas Edward), 1888–1935. | Middle East—History—1914–1923.")]), _vm._v(" "), _c('p', {
    staticClass: "cip1"
  }, [_vm._v("Classification: LCC D568.4.L45 F38 2016 | DDC 940.4/15—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("LC record available at "), _c('a', {
    staticClass: "www",
    attrs: {
      "href": "http://lccn.loc.gov/2015048301",
      "target": "_blank"
    }
  }, [_vm._v("http://lccn.loc.gov/2015048301")])]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("A catalogue record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "cip-spaced"
  }, [_vm._v("10  9  8  7  6  5  4  3  2  1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-864f5876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 63
// module chunks = 0